import React, { useEffect, useState } from "react";
import "./RightSidebar.scss";
import {
  IoVolumeMediumSharp,
  IoLogoYoutube,
  IoDocumentTextOutline,
  IoTrashOutline,
  IoOpenOutline,
  IoCloudDownloadOutline
} from "react-icons/io5";
import { FaFilePdf, FaRegImage, FaFilePowerpoint } from "react-icons/fa";
import RestClient from "../../../@core/restClient";
import Spinner from "../../widgets/UI/Spinner";
//import picture from "../../../../public/images/header-logo.png";

const DOMAIN = process.env.REACT_APP_API_URL;

const openInPowerPointOnline = (fileSrc: string) => {
  const fileUrl = encodeURIComponent(`${DOMAIN}/media/${fileSrc}`);
  window.open(`https://view.officeapps.live.com/op/view.aspx?src=${fileUrl}`, "_blank");
};

const getYouTubeId = (url: string): string | null => {
  const match = url.match(
    /(?:youtube\.com\/(?:watch\?v=|embed\/)|youtu\.be\/)([A-Za-z0-9_-]{11})/
  );
  return match ? match[1] : null;
};

const RightSidebar = ({
  openVideoBox,
  openFileLoadModal,
  fileLoadOpen,
  onCreate,
  openDeleteSong,
  collabPermission,
  songId,
  closeBothSideBars,
  openAudioBox,
  mediaPermission,
  songFiles,
  onCreatePresentation,
  presentationPermission,
  mediaRefreshKey
}: any) => {
  const [mediaList, setMediaList] = useState<any>(songFiles);
  const [renewList, setrenewList] = useState(1);
  const [isLoading, setIsLoading] = useState(false);
  const width = window.innerWidth;

  // UPDATE MEDIA ON SONG CHANGE
  useEffect(() => {
    setMediaList(songFiles);
  }, [songFiles]);

  // CLOSE SIDEBARE
  const closeSideBar = () => {
    if (width <= 992) {
      closeBothSideBars();
    }
  };

  const openFile = (link: any) => {
    window.open(`${DOMAIN}/media/${link}`, "_blank");
  };

  const saveFile = (link: any) => {
    window.open(`${DOMAIN}/media/${link}`, "_self");
  };

  const deleteFile = (id: any, e: any) => {
    e.stopPropagation();
    setIsLoading(true);
    (async () => {
      try {
        const media = await RestClient.deleteMedia(id);
        if (media) setrenewList(renewList + 1);
      } catch (error) {
        console.log("error");
      }
      // setIsLoading(false);
    })();
  };

  //UPDATE LIST OF MEDIA ON ADDING OR DELTEING MEDIA FILES

  useEffect(() => {
    if (!songId) return;
    setIsLoading(true);
    (async () => {
      try {
        const media = await RestClient.getMedia(songId);
        setMediaList(media);
      } catch (error) {
        console.log("error");
      }
      setIsLoading(false);
    })();
  }, [fileLoadOpen, renewList, songId, mediaRefreshKey]);

  return (
    <div className="right-sidebar">
      {collabPermission ? (
        <div className="right-sidebar-btns">
          <div className="btn-mcolor add-song-btn" onClick={onCreate}>
            Додати пісню
          </div>
          <div className="btn-plain delete-song-btn" onClick={openDeleteSong}>
            Видалити пісню
          </div>
        </div>
      ) : (
        ""
      )}

      <div className="right-sidebar-media">
        {isLoading ? <Spinner /> : null}
        <div className="note">Медіа ресурси для цієї пісні</div>
        {mediaList?.length !== 0 ? (
          ""
        ) : (
          <div className="note-absent">Файли відсутні</div>
        )}
      </div>
      <div className="right-sidebar-4">
        {mediaList?.map((item: any) => (
          <div key={item.id}>
            {item.type === "YouTube" ? (
              <div className="right-sidebar-4-item right-sidebar-4-item--video">
                {getYouTubeId(item.fileSrc) && (
                  <img
                    className="yt-thumbnail"
                    src={`https://img.youtube.com/vi/${getYouTubeId(item.fileSrc)}/mqdefault.jpg`}
                    alt={item.name}
                    onClick={() => { openVideoBox(item.fileSrc); closeSideBar(); }}
                  />
                )}
                <div className="right-sidebar-4-item-row">
                  <div
                    className="text"
                    onClick={() => {
                      openVideoBox(item.fileSrc);
                      closeSideBar();
                    }}
                  >
                    <IoLogoYoutube className="text-icon" /> {item.name}
                  </div>
                  {mediaPermission ? (
                    <div className="my-tooltip">
                      <IoTrashOutline
                        className="trash"
                        onClick={(e) => deleteFile(item.id, e)}
                      />
                      <span className="my-tooltip-text tooltip-bottom-left">
                        Видалити файл
                      </span>
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              </div>
            ) : item.type === "audio" ? (
              <div className="right-sidebar-4-item">
                <div
                  className="text"
                  onClick={() => {
                    openAudioBox(item.fileSrc);
                    closeSideBar();
                  }}
                >
                  {" "}
                  <IoVolumeMediumSharp className="text-icon" />
                  {item.name}
                </div>
                {mediaPermission ? (
                  <div className="my-tooltip">
                    <IoTrashOutline
                      className="trash"
                      onClick={(e) => deleteFile(item.id, e)}
                    />
                    <span className="my-tooltip-text tooltip-bottom-left">
                      Видалити файл
                    </span>
                  </div>
                ) : (
                  ""
                )}
              </div>
            ) : item.type === "image" ? (
              <div className="right-sidebar-4-item">
                <div className="text" onClick={() => openFile(item.fileSrc)}>
                  {" "}
                  <FaRegImage className="text-icon" /> {item.name}
                </div>
                {mediaPermission ? (
                  <div className="my-tooltip">
                    <IoTrashOutline
                      className="trash"
                      onClick={(e) => deleteFile(item.id, e)}
                    />
                    <span className="my-tooltip-text tooltip-bottom-left">
                      Видалити файл
                    </span>
                  </div>
                ) : (
                  ""
                )}
              </div>
            ) : item.type === "pdf" ? (
              <div className="right-sidebar-4-item">
                <div className="text" onClick={() => openFile(item.fileSrc)}>
                  {" "}
                  <FaFilePdf className="text-icon" /> {item.name}
                </div>
                {mediaPermission ? (
                  <div className="my-tooltip">
                    <IoTrashOutline
                      className="trash"
                      onClick={(e) => deleteFile(item.id, e)}
                    />
                    <span className="my-tooltip-text tooltip-bottom-left">
                      Видалити файл
                    </span>
                  </div>
                ) : (
                  ""
                )}
              </div>
            ) : item.type === "presentation" ? (
              <div className="right-sidebar-4-item right-sidebar-4-item--presentation">
                <div className="pptx-thumbnail" onClick={() => openInPowerPointOnline(item.fileSrc)}>
                  <FaFilePowerpoint className="pptx-thumbnail-icon" />
                  <span className="pptx-thumbnail-title">{item.name}</span>
                  <span className="pptx-thumbnail-sub">Презентація</span>
                </div>
                <div className="right-sidebar-4-item-row">
                  <div className="text" onClick={() => openInPowerPointOnline(item.fileSrc)}>
                    <FaFilePowerpoint className="text-icon" />
                    {item.name}
                  </div>
                  <div className="my-tooltip">
                    <IoCloudDownloadOutline
                      className="pptx-action-icon"
                      onClick={(e) => { e.stopPropagation(); saveFile(item.fileSrc); }}
                    />
                    <span className="my-tooltip-text tooltip-bottom-left">Завантажити</span>
                  </div>
                  {mediaPermission ? (
                    <div className="my-tooltip">
                      <IoTrashOutline
                        className="trash"
                        onClick={(e) => deleteFile(item.id, e)}
                      />
                      <span className="my-tooltip-text tooltip-bottom-left">
                        Видалити файл
                      </span>
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              </div>
            ) : (
              <div className="right-sidebar-4-item">
                <div className="text" onClick={() => saveFile(item.fileSrc)}>
                  {" "}
                  <IoDocumentTextOutline className="text-icon" /> {item.name}
                </div>
                {mediaPermission ? (
                  <div className="my-tooltip">
                    <IoTrashOutline
                      className="trash"
                      onClick={(e) => deleteFile(item.id, e)}
                    />
                    <span className="my-tooltip-text tooltip-bottom-left">
                      Видалити файл
                    </span>
                  </div>
                ) : (
                  ""
                )}
              </div>
            )}
          </div>
        ))}

        {mediaPermission ? (
          <p
            className="btn-plain aditional-files"
            onClick={(e) => openFileLoadModal(e)}
          >
            Завантажити
          </p>
        ) : (
          ""
        )}

        {(collabPermission || presentationPermission) && (
          <div className="btn-mcolor create-presentation-btn" onClick={onCreatePresentation}>
            Створити презентацію
          </div>
        )}
      </div>
    </div>
  );
};

export default RightSidebar;
